/* eslint-disable */
export default {
  logged: 'Registrados',
  unlogged: 'Sem funcionamento',
  faxNotSupported: 'Não há suporte para registro de fax.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
